import { render } from "./Container2.vue?vue&type=template&id=1fceb5c4&ts=true"
import script from "./Container2.vue?vue&type=script&lang=ts"
export * from "./Container2.vue?vue&type=script&lang=ts"

import "./Container2.vue?vue&type=style&index=0&id=1fceb5c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__